import React from 'react';
import './ToggleTaskIcon.scss';

interface Props {
  isOpen: boolean;
  size?: number;
  color?: string;
}

const ToggleTaskIcon: React.FC<Props> = ({ isOpen, size = 24, color = '#333' }) => {
  return (
    <div
      className={`partida-icon ${isOpen ? 'expanded' : 'collapsed'}`}
      style={{ width: size, height: size }}
    >
      <svg
        viewBox="0 0 24 24"
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
      >
        <line x1="5" y1="12" x2="19" y2="12" className="hideable" />
        <line x1="12" y1="5" x2="12" y2="19" className="permanent" />
      </svg>
    </div>
  );
};

export default ToggleTaskIcon;